import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import style from './LoadingIndicator.module.scss';
import { AppState } from '../../../store';
import { SystemState } from '../../../store/system/types';

interface LoadingIndicatorProps {
    system: SystemState;
}

const LOGO_URL = 'https://repositorysmilemed.blob.core.windows.net/images/logos/sinfondosolologotbc.png';

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ system }) => {
    if (!system.showLoading) return <Fragment />;

    return ReactDOM.createPortal(
        <div className={style['loading-indicator']} role="status" aria-live="polite">
            <div className={style['loading-card']}>
                <div className={style['loading-orbit']}>
                    <span />
                    <span />
                    <img loading="lazy" src={LOGO_URL} alt="The Blue Coding" />
                </div>
                <div className={style['loading-copy']}>
                    <strong>Cargando</strong>
                    <p>Preparando tu portal</p>
                </div>
                <div className={style['loading-bar']}>
                    <span />
                </div>
            </div>
        </div>,
        document.body
    );
};

const mapStateToProps = (state: AppState) => ({
    system: state.system
});

export default connect(mapStateToProps)(LoadingIndicator);
